module.exports = __webpack_public_path__ + "img/pro_mega10_06.54d796fe.jpg";